/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Network-aware translate: LocalNetworkProfile override, then ngx-translate,
 * then optional default when the key is missing.
 */
import {isMissingTranslateKey, reportMissingTranslateKey} from './missing-translate-key';

export function ogTranslate(
  code: string,
  defaultText: string | undefined,
  getNetworkTranslations: (key: string) => string | null | undefined,
  translateInstant: (key: string, interpolateParams?: object) => string,
  interpolateParams?: object
): string {
  // ngx-translate throws if key is null/undefined/''.
  if (isMissingTranslateKey(code)) {
    reportMissingTranslateKey({
      source: 'ogTranslate',
      key: code,
      defaultText,
      interpolateParams
    });
    return defaultText || '';
  }
  const networkTranslation = getNetworkTranslations(code);
  if (networkTranslation) {
    return networkTranslation;
  }
  const trans = translateInstant(code, interpolateParams);
  return defaultText && trans === code ? defaultText : trans;
}
